import { platformStats } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="relative -mt-10 md:-mt-14 z-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl px-6 py-5 md:px-10 md:py-7 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {platformStats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center gap-1.5">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-primary-100">
                <i className={`${stat.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <span className="text-lg md:text-2xl font-bold text-foreground-900 whitespace-nowrap">{stat.value}</span>
              <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}